import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=7d10d97b&"
import script from "./Widget.vue?vue&type=script&lang=ts&"
export * from "./Widget.vue?vue&type=script&lang=ts&"
import style0 from "./Widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports